import React, { useEffect, useState } from 'react'
import { SidePane } from '../../../Common/fSidePane/RightPane'
import { get } from '../../../../Model/Network/Config/Axios';
import { handleError } from '../../../Common/fToast/ToastCallback';
import Spinner from 'react-spinner-material';
import Track from '../../../Common/fTrack';
import Moment from 'moment';
import TabSwtich from '../../../Common/fTabSwitch';
import ReferenceType from './ReferenceType';
import Invoice from '../../fVendor/PaymentAdvice/PaymentAdviceDetails/Invoice';

function Detail({ onClose, onReaload, id }) {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [getTab, setTab] = useState(1);
    const [invoices,setInvoices] = useState([])

    useEffect(() => {
        INIT();
    }, [id])

    const INIT = () => {
        get(`settlements/settlementRequest/${id}/details`, (e, r) => {
            if (r) {
                setData(r);
                setLoading(false);
            } else {
                handleError(e);
            }
        })
    }
    let tabs = [
        {
            name: 'Details', active: getTab === 1, onClick: () => {
                setTab(1)
            }
        },
        ...(data && data.referenceType==="PAYMENT_TICKET")?[{
            name: 'Invoices', active: getTab === 3, onClick: () => {
                setTab(3)
            }
        }]:[],
        {
            name: 'Timeline', active: getTab === 2, onClick: () => {
                setTab(2)
            }
        },
    ]
    return (
        <SidePane onClose={onClose} onReload={onReaload} button="">
            {loading ? <Spinner /> :
                <div className='FadeRight-Effect' style={{ fontSize: '12px' }}>
                    <div style={{ fontWeight: 600, fontSize: '18px', lineHeight: '1.3' }} >Settlement Approval</div>
                    <div style={{ color: 'var(--text-color)', marginBottom: '35px', fontWeight: 600, fontSize: '24px', lineHeight: '1.3' }}>{data.settlementRequestId}</div>
                    <TabSwtich tabs={tabs} />
                    {
                        getTab === 1 ?
                            <>
                                <ReferenceType AmountDetails={data} setInvoices={setInvoices} referenceType={(data&&data.referenceType)?data.referenceType:undefined} id={(data && data.referenceId)?data.referenceId:undefined}/>
                                <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Status</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '10px', marginLeft: '-10px' }}>
                                    <div className='capsule capsule-solid' style={{ background: 'var(--blue-color)', color: 'var(--white-color)', marginLeft: '10px', marginTop: '10px', padding: '6px 12px', borderRadius: '6px', border: 'none' }}>{data.status} </div>
                                </div>
                            </> : null
                    }
                    {
                        getTab === 3 ?
                            <>
                                <Invoice style={{minWidth: '215px', maxWidth: '215px'}} items={(invoices && invoices.length)?invoices:[]} />
                            </> : null
                    }
                    {
                        getTab === 2 ?
                            <>
                                <Track stages={
                                    [...data.timelines.map((log, index) => {

                                        let DESC = <div><b>{log.name}</b><br />
                                            <div style={{ marginTop: '5px' }}>Type: {log.type}</div>
                                            <div style={{ marginTop: '5px' }}>Status: {log.status}</div>

                                            <div style={{ marginTop: '5px' }}>Sent
                                                on: {Moment(log.time).format("hh:mm a DD MMM YY")}
                                                <br />{log.actionTime && log.status !== 'PENDING' ? `Approved on: ${Moment(log.actionTime).format(" hh:mm a DD MMM YY")}` : ''}
                                            </div>
                                        </div>

                                        return (
                                            {
                                                title: log.email,
                                                desc: DESC,
                                                status: log.type === 'start' || log.type === 'scanner-end' || (log.type === 'scanner-start' && data.timelines.length > (index + 1)) ? true : log.status ? log.status === 'COMPLETED' || log.status === 'CANCELLED' : log.name === 'Finance Action' ? true : false
                                            })
                                    })]
                                } />
                            </> : null
                    }
                </div>
            }
        </SidePane>
    )
}

export default Detail